import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';

import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { FormsModule } from '@angular/forms';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { jkLib } from '../../services/jkCommon';
import { idNameItem } from '../../services/jkInterface';

@Component({
    selector: 'app-jklookup',
    templateUrl: './jklookup.component.html',
    styleUrls: ['./jklookup.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    JkfieldlabelComponent,
    FormsModule
],
})
export class JklookupComponent extends JkBaseComponent  implements OnInit {
  override comType: string = 'jklookup';
  // TODO: Skipped for migration because:
  //  This input overrides a field from a superclass, while the superclass field
  //  is not migrated.
  @Input()
  override flexStyle:any = { display: 'flex'};
  public items: idNameItem[] = []; // idNameItem
  /**
   * dataSource = items,為了相容 devextreme 的 dataSource
   */
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set dataSource(value: idNameItem[]) {// idNameItem
    this.items = value;
  }
  readonly valueExpr = input<string>('id');
  readonly displayExpr = input<string>('name');
  readonly type = input<string>(''); // validate type,EX: required
  public readonly interface = input('popover'); // popover action-sheet action-sheet
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  value: string='';
  readonly valueChange = output<string>();
  onValueChange(newValue: string) {
    if(this.valueChange)
    this.valueChange.emit(newValue);
  }
  matValueChange(newValue: Event) {
    //if(this.onValidate){
      // this.onValidate(newValue); TODO: validate
    //}
    let v = (newValue.target as HTMLInputElement).value;
    this.value = v;
    if(this.valueChange)
      this.valueChange.emit(this.value);
  }

  // @Input()  width: number = 200;
  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  addWhere(where: string,fieldName:string,condition:string = '='): string {
    if(this.value){
      //where += ' AND ('+fieldName + ' = ' + jkLib.quotedStr(this.value)+') ';
      where = jkLib.text2Where(this.value, where, fieldName, condition);
    }
    return where;
  }

}
